<ngx-bootstrap-multiselect
  [options]="regions"
  [settings]="dropdownSettings"
  [(ngModel)]="selectedRegion">
</ngx-bootstrap-multiselect>
